import { unref } from '@vue/composition-api';
import { useMutation, useQueryClient } from 'vue-query';
import { deleteCart } from '@/api/orderSend/orderSend';

import AlarmMsg from '@/utils/alarmMsg';

export default function useRemoveCartAPI({ mutationKey, onError, onMutate, onSettled, onSuccess, useErrorBoundary } = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    async (cartSeq) => {
      const cartSeqs = (() => {
        const origin = unref(cartSeq);
        if (Array.isArray(origin)) return origin.map(Number);
        if (!origin) return [];
        return [Number(origin)];
      })();

      if (!cartSeqs.length) throw new Error('cartSeq is empty');

      const response = await deleteCart({
        cartSeq: cartSeqs,
        removeType: cartSeqs.length > 1 ? 'SELECT' : 'ONE',
      });

      const { code, message, result } = response;

      if (code !== 'SUC0000') {
        AlarmMsg.getMsg(response);
        throw new Error(`${code}: ${message}`);
      }

      return result;
    },
    {
      mutationKey,
      onError,
      onMutate,
      onSettled,
      onSuccess: (...args) => {
        queryClient.invalidateQueries('cart');
        onSuccess?.(...args);
      },
      useErrorBoundary,
    },
  );
}
